<form [formGroup]="overigeOnroerendeZaken">
    <div *ngIf="box3OverigeOnroerendeZaken.length > 0" class="row">
        <div formArrayName="box3OverigeOnroerendeZaken">
            <div *ngFor="let item of box3OverigeOnroerendeZaken.controls; let i = index; "
                 [formGroupName]="i">
                <div class="row ">
                    <div class="col-auto row " formGroupName="adres">
                        <snelstart-ui-select-form-control (change)="saveForm()"
                                                          [label]="i === 0 ? 'Land' : ''"
                                                          [options]="optionsLandcodes"
                                                          [required]=true
                                                          class="col-auto custom-input-200"
                                                          formControlName="landCode"
                        >
                        </snelstart-ui-select-form-control>
                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                        [label]="i === 0 ? 'Postcode' : ''"
                                                        class="col-auto custom-input-150"
                                                        formControlName="postcode"
                                                        id="postcode"
                        >
                        </snelstart-ui-text-form-control>
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [decimals]="0"
                                                          [label]="i === 0 ? 'Huisnr.' : ''"
                                                          [maxValue]="99999"
                                                          class="col-auto custom-input-100"
                                                          formControlName="huisNummer"
                                                          id="huisNummer"
                        >
                        </snelstart-ui-number-form-control>
                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                        [label]="i === 0 ? 'Toev.' : ''"
                                                        class="col-auto custom-input-100"
                                                        formControlName="huisNummerToevoeging"
                                                        id="huisNummerToevoeging"
                        >
                        </snelstart-ui-text-form-control>
                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                        [label]="i === 0 ? 'Plaats' : ''"
                                                        class="col-auto custom-input-175"
                                                        formControlName="woonplaats"
                                                        id="woonplaats"
                        >
                        </snelstart-ui-text-form-control>
                    </div>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [label]="i === 0 ? '% Eigendom' : ''"
                                                      [maxValue]="100.00"
                                                      [showAllDecimals]="true"
                                                      class="col-auto custom-input-125"
                                                      formControlName="percentageEigendom"
                                                      id="percentageEigendom"
                                                      label="Percentage eigendom"
                                                      postfix="%"
                    >
                    </snelstart-ui-number-form-control>
                    <div class="row col-auto">
                        <snelstart-ui-button
                                (click)="this.showDialogGegevens(i)"
                                [class]="i === 0 ? 'pt-3 custom-input-175' : 'custom-input-175'"
                                icon="plus"
                                type="secondary">
                            Gegevens 1-1
                        </snelstart-ui-button>
                    </div>
                    @if (this.incomeTaxEntity.aangifte?.box3?.berekenWerkelijkRendement) {
                        <snelstart-ui-button
                                (click)="this.showDialogOwr(i)"
                                [class]="i === 0 ? 'pt-3 custom-input-125' : 'custom-input-125'"
                                [icon]="heeftOWR[i] ? 'check' : 'plus'"
                                type="secondary">
                            OWR
                        </snelstart-ui-button>
                    }

                    <snelstart-ui-button (click)="verwijderRijOverigeOnroerendeZaken(i)"
                                         [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                         icon="trash"
                                         iconType="light"
                                         id="buttonDeleteKosten"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>

                @if (box3OverigeOnroerendeZaken.controls[i].get('adres.landCode')?.value === 'NLD') {
                    @if (box3OverigeOnroerendeZaken.controls[i].get('adres.woonplaats')?.value?.length > 0 &&
                    box3OverigeOnroerendeZaken.controls[i].get('adres.postcode')?.value?.length < 1) {
                        <div class="pb-2 ps-1" style="color: crimson">
                            Let op! Is er geen postcode en/of huisnummer bekend? Vul dan '1234AB' en/of '1' in.
                        </div>
                    }
                    @if (box3OverigeOnroerendeZaken.controls[i].get('adres.postcode')?.value?.length > 9) {
                        <div class="pb-2 ps-1" style="color: crimson">
                            Let op! De buitenlandse postcode mag maximaal 9 karakters bevatten.
                        </div>
                    }
                }

                @if (box3OverigeOnroerendeZaken.controls[i].get('adres.landCode')?.value !== 'NLD') {
                    @if (box3OverigeOnroerendeZaken.controls[i].get('adres.postcode')?.value?.length < 1) {
                        <div class="pb-2 ps-1" style="color: crimson">
                            Let op! Is er geen buitenlandse postcode en/of huisnummer bekend? Vul dan '1111' en/of '1'
                            in.
                        </div>
                    }
                    @if (box3OverigeOnroerendeZaken.controls[i].get('adres.postcode')?.value?.length > 9) {
                        <div class="pb-2 ps-1" style="color: crimson">
                            Let op! De buitenlandse postcode mag maximaal 9 karakters bevatten.
                        </div>
                    }
                }
            </div>
        </div>
    </div>
</form>


<div *ngIf="box3OverigeOnroerendeZaken.length === 0">
    <snelstart-ui-button (click)="addRijOverigeOnroerendeZaken()" class="snelstart-ui-button" icon="plus"
                         type="link">Onroerende zaak invullen
    </snelstart-ui-button>
</div>
<div *ngIf="box3OverigeOnroerendeZaken.length > 0">
    <snelstart-ui-button (click)="addRijOverigeOnroerendeZaken()" class="snelstart-ui-button" icon="plus"
                         type="link">Onroerende zaak toevoegen
    </snelstart-ui-button>
</div>

<snelstart-ui-dialog-definition [(visible)]="dialogGegevensVisible"
                                [title]="getGegevensDialogTitel(index)"
                                id="overigeOnroerendeZakenVerhuur"
                                size="lg">

    <snelstart-ui-dialog-body>
        <form [formGroup]="overigeOnroerendeZaken">
            <div class="flex-container-dialog">
                <div formArrayName="box3OverigeOnroerendeZaken">
                    <div *ngFor="let oz of box3OverigeOnroerendeZaken.controls; let i = index; "
                         [formGroupName]="i">
                        <div *ngIf="i === this.index">

                            <snelstart-ui-date-form-control (change)="saveForm()"
                                                            [label]="'Aankoopdatum in ' + jaar"
                                                            class="col-auto custom-input-275"
                                                            formControlName="datumGekocht"
                                                            id="datumVerkocht"
                                                            placeholder="dd-mm-{{this.incomeTaxEntity.aangifte?.aangifteJaar}}">
                            </snelstart-ui-date-form-control>

                            <!-- WONING -->
                            <div class="row align-items-center">
                                <snelstart-ui-select-form-control (change)="saveForm()"
                                                                  [options]="optionsJaNeeWoning"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="woning"
                                                                  label="Is er sprake van een woning">
                                </snelstart-ui-select-form-control>
                                <div class="col-auto pt-1">
                                    <span (mouseenter)="showHelp('woning')"
                                          (mouseleave)="hideHelp()"
                                          class="help-toggle">ⓘ</span>
                                </div>
                            </div>
                            @if (activeHelp === 'woning') {
                                <div (mouseenter)="showHelp('woning')"
                                     (mouseleave)="hideHelp()"
                                     class="help-inline">
                                    Kies 'Ja' als het gaat om een tweede woning, een verhuurde woning of een
                                    leegstaande woning. Ook bij een woning in aanbouw of bouwkavel kies je 'Ja'.
                                    Bij een andere onroerende zaak gaat het bijvoorbeeld om een bedrijfspand.
                                </div>
                            }

                            <!-- WOZ / WAARDE -->
                            <div class="row align-items-center">
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="getWozLabel(i)"
                                                                  [minValue]="0"
                                                                  [required]="true"
                                                                  align="right"
                                                                  class="col-auto custom-input-275"
                                                                  formControlName="woz"
                                                                  id="woz"
                                                                  prefix="€">
                                </snelstart-ui-number-form-control>
                                <div class="col-auto pt-1">
                                    <span (mouseenter)="showHelp('woz')"
                                          (mouseleave)="hideHelp()"
                                          class="help-toggle">ⓘ</span>
                                </div>
                            </div>
                            @if (activeHelp === 'woz') {
                                <div (mouseenter)="showHelp('woz')"
                                     (mouseleave)="hideHelp()"
                                     class="help-inline">
                                    <strong>Woning?</strong> Vul de WOZ-waarde in {{ this.jaar }} (peildatum
                                    1-1-{{ this.jaar - 1 }}) in.<br/>
                                    <strong>Bouwkavel?</strong> Vul de (verwachte) WOZ-waarde in {{ this.jaar }}
                                    (peildatum 1-1-{{ this.jaar - 1 }}) in.<br/>
                                    <strong>Andere onroerende zaak?</strong> Vul de waarde van de volle en onbezwaarde
                                    eigendom
                                    in vrij opleverbare staat in het economisch verkeer op {{ this.getDatumBegin(i) }}
                                    in.
                                </div>
                            }

                            @if (box3OverigeOnroerendeZaken.controls[i].get('woning')?.value === true) {

                                <!-- ERFPACHT -->
                                <div class="row align-items-center">
                                    <snelstart-ui-number-form-control
                                            (change)="saveForm()"
                                            [decimals]="0"
                                            [label]="'Jaarbedrag voor erfpacht in ' + this.jaar"
                                            align="right"
                                            class="col-auto custom-input-275"
                                            formControlName="betaaldeErfpachtCanon"
                                            id="disabled"
                                            prefix="€">
                                    </snelstart-ui-number-form-control>
                                    <div class="col-auto pt-1">
                                        <span (mouseenter)="showHelp('erfpacht')"
                                              (mouseleave)="hideHelp()"
                                              class="help-toggle">ⓘ</span>
                                    </div>
                                </div>
                                @if (activeHelp === 'erfpacht') {
                                    <div (mouseenter)="showHelp('erfpacht')"
                                         (mouseleave)="hideHelp()"
                                         class="help-inline">
                                        <strong>Geldt alleen voor woningen!</strong><br/>
                                        Bij erfpacht wordt de WOZ-waarde verminderd met de waarde van de toekomstige
                                        erfpachtcanons. De waarde van de toekomstige erfpachtcanons is 17 keer
                                        de jaarlijkse erfpachtcanon.
                                    </div>
                                }

                                @if (box3OverigeOnroerendeZaken.controls[i].get('adres.landCode')?.value === 'NLD') {

                                    <div class="pt-2 pb-1">
                                        <b>Alleen voor verhuurde of verpachte woning</b>
                                    </div>

                                    <div formGroupName="verhuurdOfVerpacht">

                                        <snelstart-ui-select-form-control (change)="saveForm()"
                                                                          [options]="verhuurdOfVerpachtStatus"
                                                                          class="custom-input-275 col-auto"
                                                                          formControlName="status"
                                                                          label="Is er sprake van huur of van pacht">
                                        </snelstart-ui-select-form-control>

                                        <!-- VERHUUR -->
                                        <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpacht.status')?.value === VerhuurdOfVerpachtStatus.VERHUURD">

                                            <!-- HUURBESCHERMING -->
                                            <div class="row align-items-center">
                                                <snelstart-ui-select-form-control
                                                        (change)="saveForm()"
                                                        [options]="optionsJaNeeHuurbescherming"
                                                        class="custom-input-275"
                                                        formControlName="huurbescherming"
                                                        id="huurbescherming"
                                                        label="Huurder recht op bescherming">
                                                </snelstart-ui-select-form-control>
                                                <div class="col-auto pt-1">
                                                <span (mouseenter)="showHelp('huurbescherming')"
                                                      (mouseleave)="hideHelp()"
                                                      class="help-toggle">ⓘ</span>
                                                </div>
                                            </div>
                                            @if (activeHelp === 'huurbescherming') {
                                                <div (mouseenter)="showHelp('huurbescherming')"
                                                     (mouseleave)="hideHelp()"
                                                     class="help-inline">
                                                    Huurders van de volgende woningen hebben <strong>geen</strong> recht
                                                    op huurbescherming: tijdelijk verhuurde woningen (bv. wisselwoning
                                                    tijdens renovatie), recreatiewoningen, winkelwoningen,
                                                    dienstwoningen, kamers in verpleeg- of verzorgingshuizen (als er
                                                    alleen een zorgovereenkomst is), en woningen verhuurd met een
                                                    leegstandswetvergunning met toestemming van de hypotheekverstrekker.
                                                </div>
                                            }

                                            <!-- huurbescherming JA -->
                                            <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpacht.huurbescherming')?.value === true">

                                                <!-- ZELFSTANDIG DEEL -->
                                                <div class="row align-items-center">
                                                    <snelstart-ui-select-form-control
                                                            (change)="saveForm()"
                                                            [options]="optionsJaNeeVerhuurZelfstandigDeel"
                                                            class="custom-input-275"
                                                            formControlName="zelfstandigDeelVanGroterGebouw"
                                                            id="zelfstandigDeelVanGroterGebouw"
                                                            label="Verhuur van gehele woning">
                                                    </snelstart-ui-select-form-control>
                                                    <div class="col-auto pt-1">
                                                    <span (mouseenter)="showHelp('zelfstandigDeel')"
                                                          (mouseleave)="hideHelp()"
                                                          class="help-toggle">ⓘ</span>
                                                    </div>
                                                </div>
                                                @if (activeHelp === 'zelfstandigDeel') {
                                                    <div (mouseenter)="showHelp('zelfstandigDeel')"
                                                         (mouseleave)="hideHelp()"
                                                         class="help-inline">
                                                        Kies een zelfstandig deel als het gaat om de verhuur van een
                                                        deel van een groter gebouw. Dit deel kon niet verkocht worden
                                                        zonder het pand op te splitsen.
                                                    </div>
                                                }

                                                <!-- GELIEERD -->
                                                <div class="row align-items-center">
                                                    <snelstart-ui-select-form-control
                                                            (change)="saveForm()"
                                                            [options]="optionsJaNeeOnzakelijkeHuur"
                                                            class="custom-input-275"
                                                            formControlName="onzakelijkeHuur"
                                                            id="onzakelijkeHuur"
                                                            label="Verhuur aan derde of gelieerde">
                                                    </snelstart-ui-select-form-control>
                                                    <div class="col-auto pt-1">
                                                    <span (mouseenter)="showHelp('gelieerd')"
                                                          (mouseleave)="hideHelp()"
                                                          class="help-toggle">ⓘ</span>
                                                    </div>
                                                </div>
                                                @if (activeHelp === 'gelieerd') {
                                                    <div (mouseenter)="showHelp('gelieerd')"
                                                         (mouseleave)="hideHelp()"
                                                         class="help-inline">
                                                        Als 'gelieerd' wordt beschouwd de verhuur aan een familielid.
                                                    </div>
                                                }

                                                <!-- JAARHUUR -->
                                                <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpacht.onzakelijkeHuur')?.value === false">
                                                    <div class="row align-items-center">
                                                        <snelstart-ui-number-form-control
                                                                (change)="saveForm()"
                                                                [decimals]="0"
                                                                [label]="'Huurwaarde woning op 1-1-' + this.jaar"
                                                                align="right"
                                                                class="custom-input-275 col-auto"
                                                                formControlName="jaarhuur"
                                                                id="jaarhuur"
                                                                prefix="€">
                                                        </snelstart-ui-number-form-control>
                                                        <div class="col-auto pt-1">
                                                        <span (mouseenter)="showHelp('jaarhuur')"
                                                              (mouseleave)="hideHelp()"
                                                              class="help-toggle">ⓘ</span>
                                                        </div>
                                                    </div>
                                                    @if (activeHelp === 'jaarhuur') {
                                                        <div (mouseenter)="showHelp('jaarhuur')"
                                                             (mouseleave)="hideHelp()"
                                                             class="help-inline">
                                                            Dit is de kale huur (maandhuur) op de aangegeven datum × 12.
                                                            Dit geldt ook als de woning niet het hele jaar verhuurd is.
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                        </div>

                                        <!-- VERPACHT -->
                                        <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpacht.status')?.value === VerhuurdOfVerpachtStatus.VERPACHT">
                                            <snelstart-ui-select-form-control
                                                    (change)="saveForm()"
                                                    [options]="optionsJaNeePachtZelfstandigDeel"
                                                    class="custom-input-275"
                                                    formControlName="zelfstandigDeelVanGroterGebouw"
                                                    id="zelfstandigDeelVanGroterGebouw3"
                                                    label="Verpachting van gehele woning">
                                            </snelstart-ui-select-form-control>

                                            <snelstart-ui-select-form-control
                                                    (change)="saveForm()"
                                                    [options]="optionsJaNeeOvereenkomst"
                                                    class="custom-input-275"
                                                    formControlName="overeenkomstMeerDan12Jaar"
                                                    id="overeenkomstMeerDan12Jaar"
                                                    label="Looptijd overeenkomst minimaal 12 jaar">
                                            </snelstart-ui-select-form-control>

                                            <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpacht.overeenkomstMeerDan12Jaar')?.value === true">
                                                <snelstart-ui-select-form-control
                                                        (change)="saveForm()"
                                                        [options]="optionsJaNeeOnzakelijkePacht"
                                                        class="custom-input-275"
                                                        formControlName="onzakelijkePacht"
                                                        id="onzakelijkePacht"
                                                        label="Is de pacht zakelijk">
                                                </snelstart-ui-select-form-control>
                                            </div>

                                            <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpacht.onzakelijkePacht')?.value === false">
                                                <snelstart-ui-number-form-control
                                                        (change)="saveForm()"
                                                        [decimals]="0"
                                                        [label]="'Ontvangen pacht op 1-1-' + this.jaar"
                                                        align="right"
                                                        class="custom-input-275"
                                                        formControlName="jaarpacht"
                                                        id="jaarpacht"
                                                        prefix="€">
                                                </snelstart-ui-number-form-control>
                                            </div>
                                        </div>

                                        <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpacht.status')?.value === VerhuurdOfVerpachtStatus.VERHUURD ||
                                        box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpacht.status')?.value === VerhuurdOfVerpachtStatus.VERPACHT"
                                             class="pb-2">
                                            <snelstart-ui-button (click)="resetVerhuurdOfVerpacht(i);"
                                                                 iconRight="trash"
                                                                 iconType="light"
                                                                 size="small"
                                                                 type="link">
                                                <i>Geen huur/pacht? Verwijder!</i>
                                            </snelstart-ui-button>
                                        </div>
                                    </div>
                                }
                            }
                            <div class="pt-2 pb-2">
                                <div class="d-flex align-items-center">
                                    <div class="result-inline">
                                        @let waardeBegin = getBerekendeWaardeBegin(i);
                                        Berekende waarde per {{ this.getDatumBegin(i) }}:
                                        € {{ waardeBegin | number:'1.0-0' }}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </form>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>


<snelstart-ui-dialog-definition [(visible)]="dialogOwrVisible"
                                [title]="getOWRDialogTitel(index)"
                                id="owrBank"
                                size="lg">
    <snelstart-ui-dialog-body>
        <form [formGroup]="overigeOnroerendeZaken">
            <div class="flex-container-dialog">
                <div formArrayName="box3OverigeOnroerendeZaken">
                    <div *ngFor="let oz of box3OverigeOnroerendeZaken.controls; let i = index; "
                         [formGroupName]="i">
                        <div *ngIf="i === this.index">

                            <snelstart-ui-date-form-control (change)="saveForm()"
                                                            [label]="'Verkoopdatum in ' + jaar"
                                                            class="col-auto custom-input-275"
                                                            formControlName="datumVerkocht"
                                                            id="datumVerkocht"
                                                            placeholder="dd-mm-{{this.incomeTaxEntity.aangifte?.aangifteJaar}}">
                            </snelstart-ui-date-form-control>

                            <!-- WOZ EIND -->
                            <div class="row align-items-center">
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="getWozLabelEind(i)"
                                                                  [minValue]="0"
                                                                  [required]="true"
                                                                  align="right"
                                                                  class="col-auto custom-input-275"
                                                                  formControlName="wozPlusEen"
                                                                  id="woz"
                                                                  prefix="€">
                                </snelstart-ui-number-form-control>
                                <div class="col-auto pt-1">
                                    <span (mouseenter)="showHelp('wozEind')"
                                          (mouseleave)="hideHelp()"
                                          class="help-toggle">ⓘ</span>
                                </div>
                            </div>
                            @if (activeHelp === 'wozEind') {
                                <div (mouseenter)="showHelp('wozEind')"
                                     (mouseleave)="hideHelp()"
                                     class="help-inline">
                                    <strong>Woning?</strong> Vul de WOZ-waarde in {{ this.jaar + 1 }} (peildatum
                                    1-1-{{ this.jaar }}) in.<br/>
                                    <strong>Bouwkavel?</strong> Vul de (verwachte) WOZ-waarde in {{ this.jaar + 1 }}
                                    (peildatum 1-1-{{ this.jaar }}) in.<br/>
                                    <strong>Andere onroerende zaak?</strong> Vul de waarde van de volle en onbezwaarde
                                    eigendom
                                    in vrij opleverbare staat in het economisch verkeer op {{ this.getDatumEind(i) }}
                                    in.
                                </div>
                            }

                            <!-- INVESTERING -->
                            <div class="row align-items-center">
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  [label]="'Investering in onroerende zaak in ' + this.jaar"
                                                                  align="right"
                                                                  class="custom-input-275 col-auto"
                                                                  formControlName="investeringen"
                                                                  id="bedrag"
                                                                  prefix="€">
                                </snelstart-ui-number-form-control>
                                <div class="col-auto pt-1">
                                    <span (mouseenter)="showHelp('investering')"
                                          (mouseleave)="hideHelp()"
                                          class="help-toggle">ⓘ</span>
                                </div>
                            </div>
                            @if (activeHelp === 'investering') {
                                <div (mouseenter)="showHelp('investering')"
                                     (mouseleave)="hideHelp()"
                                     class="help-inline">
                                    Het gaat om uitgaven gedaan om de onroerende zaak te verbeteren of uit te breiden,
                                    bijvoorbeeld door het plaatsen van een serre. Het geldt ook als investering wanneer:
                                    de verkoper investeringen had gedaan, de koper investeringen had gedaan,
                                    of er bouwtermijnen uit een bouwdepot zijn betaald voor aanbouw of verbouwing.
                                    Ook als er in {{ this.jaar }} jaarlijkse erfpachtcanons voor altijd is afgekocht,
                                    geldt dit als investering.
                                </div>
                            }

                            <!-- VERHOGING WOZ DOOR INVESTERING -->
                            <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('investeringen')?.value > 0">
                                <div class="row align-items-center">
                                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                                      [decimals]="0"
                                                                      [label]="'Verhoging WOZ ' + (this.jaar + 1) + ' door investering'"
                                                                      align="right"
                                                                      class="custom-input-275 col-auto"
                                                                      formControlName="waardestijgingWOZwaardeWegensInvesteringen"
                                                                      id="bedrag"
                                                                      prefix="€">
                                    </snelstart-ui-number-form-control>
                                    <div class="col-auto pt-1">
                                        <span (mouseenter)="showHelp('invVerhoging')"
                                              (mouseleave)="hideHelp()"
                                              class="help-toggle">ⓘ</span>
                                    </div>
                                </div>
                                @if (activeHelp === 'invVerhoging') {
                                    <div (mouseenter)="showHelp('invVerhoging')"
                                         (mouseleave)="hideHelp()"
                                         class="help-inline">
                                        Vul in: de verhoging van de (WOZ-)waarde als gevolg van de investering.
                                        Neem bij afkoop erfpacht het bedrag over dat u hebt ingevuld bij 'Bedrag van de
                                        investering'.
                                        De verhoging kan nooit meer zijn dan de investering.
                                        <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('adres.landCode')?.value !== 'NLD'">
                                            <br/>Gaat het om een woning in het buitenland? En steeg deze woning hierdoor
                                            in waarde?
                                            Dan kunt u deze stijging aantonen met een taxatierapport of met een
                                            waardering van
                                            een lokale overheid op basis van de waarde in vrij opleverbare staat.
                                        </div>
                                    </div>
                                }
                            </div>

                            <!-- HUUROPBRENGSTEN -->
                            <div class="row align-items-center">
                                <snelstart-ui-number-form-control
                                        (change)="saveForm()"
                                        [decimals]="0"
                                        [label]="'Ontvangen huuropbrengsten in ' + this.jaar"
                                        align="right"
                                        class="custom-input-275 col-auto"
                                        formControlName="directRendement"
                                        id="bedrag"
                                        prefix="€">
                                </snelstart-ui-number-form-control>
                                <div class="col-auto pt-1">
                                        <span (mouseenter)="showHelp('huuropbrengsten')"
                                              (mouseleave)="hideHelp()"
                                              class="help-toggle">ⓘ</span>
                                </div>
                            </div>
                            @if (activeHelp === 'huuropbrengsten') {
                                <div (mouseenter)="showHelp('huuropbrengsten')"
                                     (mouseleave)="hideHelp()"
                                     class="help-inline">
                                    Het gaat om de kale huurprijs die de huurder in {{ this.jaar }} direct of
                                    indirect betaalde.
                                    De kale huurprijs is het bedrag dat de verhuurder in rekening brengt aan de
                                    huurder om in
                                    het pand te mogen verblijven. Een vergoeding voor gas, water en licht en
                                    eventuele btw
                                    horen niet bij de kale huurprijs. De kosten zoals service-, administratiekosten
                                    en
                                    gemeentelijke heffingen mag je niet aftrekken.
                                </div>
                            }

                            @if (box3OverigeOnroerendeZaken.controls[i].get('woning')?.value === true) {

                                <!-- ERFPACHT EINDE JAAR -->
                                <div class="row align-items-center">
                                    <snelstart-ui-number-form-control
                                            (change)="saveForm()"
                                            [decimals]="0"
                                            [label]="'Jaarbedrag voor erfpacht in ' + (this.jaar + 1)"
                                            align="right"
                                            class="col-auto custom-input-275"
                                            formControlName="betaaldeErfpachtCanonEindeJaar"
                                            id="disabled"
                                            prefix="€">
                                    </snelstart-ui-number-form-control>
                                    <div class="col-auto pt-1">
                                        <span (mouseenter)="showHelp('erfpachtEind')"
                                              (mouseleave)="hideHelp()"
                                              class="help-toggle">ⓘ</span>
                                    </div>
                                </div>
                                @if (activeHelp === 'erfpachtEind') {
                                    <div (mouseenter)="showHelp('erfpachtEind')"
                                         (mouseleave)="hideHelp()"
                                         class="help-inline">
                                        Vul het bedrag in voor een erfpachtcanon op jaarbasis die gold op
                                        1 januari {{ this.jaar + 1 }}. Als er niet voor het hele jaar betaald is,
                                        bijvoorbeeld omdat de woning in het jaar gekocht is, vul je toch het jaarbedrag
                                        in.
                                    </div>
                                }

                                @if (box3OverigeOnroerendeZaken.controls[i].get('adres.landCode')?.value === 'NLD') {

                                    <div class="pt-2 pb-1">
                                        <b>Alleen voor verhuurde of verpachte woning</b>
                                    </div>

                                    <div formGroupName="verhuurdOfVerpachtOpEinddatum">

                                        <snelstart-ui-select-form-control (change)="saveForm()"
                                                                          [options]="verhuurdOfVerpachtStatus"
                                                                          class="custom-input-275 col-auto"
                                                                          formControlName="status"
                                                                          label="Is er sprake van huur of van pacht">
                                        </snelstart-ui-select-form-control>

                                        <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpachtOpEinddatum.status')?.value === VerhuurdOfVerpachtStatus.VERHUURD">

                                            <!-- HUURBESCHERMING EIND -->
                                            <div class="row align-items-center">
                                                <snelstart-ui-select-form-control
                                                        (change)="saveForm()"
                                                        [options]="optionsJaNeeHuurbescherming"
                                                        class="custom-input-275"
                                                        formControlName="huurbescherming"
                                                        id="huurbescherming"
                                                        label="Huurder recht op bescherming">
                                                </snelstart-ui-select-form-control>
                                                <div class="col-auto pt-1">
                                                <span (mouseenter)="showHelp('huurbeschermingEind')"
                                                      (mouseleave)="hideHelp()"
                                                      class="help-toggle">ⓘ</span>
                                                </div>
                                            </div>
                                            @if (activeHelp === 'huurbeschermingEind') {
                                                <div (mouseenter)="showHelp('huurbeschermingEind')"
                                                     (mouseleave)="hideHelp()"
                                                     class="help-inline">
                                                    Huurders van de volgende woningen hebben <strong>geen</strong> recht
                                                    op huurbescherming: tijdelijk verhuurde woningen (bv. wisselwoning
                                                    tijdens renovatie), recreatiewoningen, winkelwoningen,
                                                    dienstwoningen, kamers in verpleeg- of verzorgingshuizen (als er
                                                    alleen een zorgovereenkomst is), en woningen verhuurd met een
                                                    leegstandswetvergunning met toestemming van de hypotheekverstrekker.
                                                </div>
                                            }

                                            <!-- huurbescherming JA -->
                                            <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpachtOpEinddatum.huurbescherming')?.value === true">

                                                <!-- ZELFSTANDIG DEEL EIND -->
                                                <div class="row align-items-center">
                                                    <snelstart-ui-select-form-control
                                                            (change)="saveForm()"
                                                            [options]="optionsJaNeeVerhuurZelfstandigDeel"
                                                            class="custom-input-275"
                                                            formControlName="zelfstandigDeelVanGroterGebouw"
                                                            id="zelfstandigDeelVanGroterGebouw"
                                                            label="Verhuur van gehele woning">
                                                    </snelstart-ui-select-form-control>
                                                    <div class="col-auto pt-1">
                                                    <span (mouseenter)="showHelp('zelfstandigDeelEind')"
                                                          (mouseleave)="hideHelp()"
                                                          class="help-toggle">ⓘ</span>
                                                    </div>
                                                </div>
                                                @if (activeHelp === 'zelfstandigDeelEind') {
                                                    <div (mouseenter)="showHelp('zelfstandigDeelEind')"
                                                         (mouseleave)="hideHelp()"
                                                         class="help-inline">
                                                        Kies een zelfstandig deel als het gaat om de verhuur van een
                                                        deel van een groter gebouw. Dit deel kon niet verkocht worden
                                                        zonder het pand op te splitsen.
                                                    </div>
                                                }

                                                <!-- GELIEERD EIND -->
                                                <div class="row align-items-center">
                                                    <snelstart-ui-select-form-control
                                                            (change)="saveForm()"
                                                            [options]="optionsJaNeeOnzakelijkeHuur"
                                                            class="custom-input-275"
                                                            formControlName="onzakelijkeHuur"
                                                            id="onzakelijkeHuur"
                                                            label="Verhuur aan derde of gelieerde">
                                                    </snelstart-ui-select-form-control>
                                                    <div class="col-auto pt-1">
                                                    <span (mouseenter)="showHelp('gelieerdEind')"
                                                          (mouseleave)="hideHelp()"
                                                          class="help-toggle">ⓘ</span>
                                                    </div>
                                                </div>
                                                @if (activeHelp === 'gelieerdEind') {
                                                    <div (mouseenter)="showHelp('gelieerdEind')"
                                                         (mouseleave)="hideHelp()"
                                                         class="help-inline">
                                                        Als 'gelieerd' wordt beschouwd de verhuur aan een familielid.
                                                    </div>
                                                }

                                                <!-- JAARHUUR EIND -->
                                                <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpachtOpEinddatum.onzakelijkeHuur')?.value === false">
                                                    <div class="row align-items-center">
                                                        <snelstart-ui-number-form-control
                                                                (change)="saveForm()"
                                                                [decimals]="0"
                                                                [label]="'Huurwaarde woning op 1-1-' + (this.jaar + 1)"
                                                                align="right"
                                                                class="custom-input-275 col-auto"
                                                                formControlName="jaarhuur"
                                                                id="jaarhuur"
                                                                prefix="€">
                                                        </snelstart-ui-number-form-control>
                                                        <div class="col-auto pt-1">
                                                        <span (mouseenter)="showHelp('jaarhuurEind')"
                                                              (mouseleave)="hideHelp()"
                                                              class="help-toggle">ⓘ</span>
                                                        </div>
                                                    </div>
                                                    @if (activeHelp === 'jaarhuurEind') {
                                                        <div (mouseenter)="showHelp('jaarhuurEind')"
                                                             (mouseleave)="hideHelp()"
                                                             class="help-inline">
                                                            Dit is de kale huur (maandhuur) op de aangegeven datum × 12.
                                                            Dit geldt ook als de woning niet het hele jaar verhuurd is.
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <!-- VERPACHT -->
                                        <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpachtOpEinddatum.status')?.value === VerhuurdOfVerpachtStatus.VERPACHT">
                                            <snelstart-ui-select-form-control
                                                    (change)="saveForm()"
                                                    [options]="optionsJaNeePachtZelfstandigDeel"
                                                    class="custom-input-275"
                                                    formControlName="zelfstandigDeelVanGroterGebouw"
                                                    id="zelfstandigDeelVanGroterGebouw3"
                                                    label="Verpachting van gehele woning">
                                            </snelstart-ui-select-form-control>

                                            <snelstart-ui-select-form-control
                                                    (change)="saveForm()"
                                                    [options]="optionsJaNeeOvereenkomst"
                                                    class="custom-input-275"
                                                    formControlName="overeenkomstMeerDan12Jaar"
                                                    id="overeenkomstMeerDan12Jaar"
                                                    label="Looptijd overeenkomst minimaal 12 jaar">
                                            </snelstart-ui-select-form-control>

                                            <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpachtOpEinddatum.overeenkomstMeerDan12Jaar')?.value === true">
                                                <snelstart-ui-select-form-control
                                                        (change)="saveForm()"
                                                        [options]="optionsJaNeeOnzakelijkePacht"
                                                        class="custom-input-275"
                                                        formControlName="onzakelijkePacht"
                                                        id="onzakelijkePacht"
                                                        label="Is de pacht zakelijk">
                                                </snelstart-ui-select-form-control>
                                            </div>

                                            <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpachtOpEinddatum.onzakelijkePacht')?.value === false">
                                                <snelstart-ui-number-form-control
                                                        (change)="saveForm()"
                                                        [decimals]="0"
                                                        [label]="'Ontvangen pacht op 1-1-' + this.jaar + 1"
                                                        align="right"
                                                        class="custom-input-275"
                                                        formControlName="jaarpacht"
                                                        id="jaarpacht"
                                                        prefix="€">
                                                </snelstart-ui-number-form-control>
                                            </div>
                                        </div>

                                        <div *ngIf="box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpachtOpEinddatum.status')?.value === VerhuurdOfVerpachtStatus.VERHUURD ||
                                        box3OverigeOnroerendeZaken.controls[i].get('verhuurdOfVerpachtOpEinddatum.status')?.value === VerhuurdOfVerpachtStatus.VERPACHT"
                                             class="pb-2">
                                            <snelstart-ui-button (click)="resetVerhuurdOfVerpachtOpEinddatum(i)"
                                                                 icon="trash"
                                                                 iconColor="grey"
                                                                 iconType="light"
                                                                 size="small"
                                                                 type="link">
                                                <i>Geen huur/pacht? Verwijder!</i>
                                            </snelstart-ui-button>
                                        </div>
                                    </div>
                                }
                            }
                            <div class="pt-2 pb-2">
                                <div class="d-flex align-items-center">
                                    <div class="result-inline">
                                        @let rendementOG = getBerekendeWerkelijkRendement(i);
                                        Berekend werkelijk rendement {{ this.jaar }}:
                                        € {{ rendementOG | number:'1.0-0' }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

